import { BackgroundProcessor, SwitchBackgroundProcessorOptions } from 'features/VirtualBackground/source';
import { BackgroundProcessorWrapper } from '../types';
import { IBackgroundProcessorConfigProvider, IBackgroundProcessorFactory } from '../types/backgroundProcessor';

export class BackgroundProcessorFactory implements IBackgroundProcessorFactory {
    public constructor(private configProvider: IBackgroundProcessorConfigProvider) {}

    public createProcessor(): BackgroundProcessorWrapper {
        const options = this.configProvider.getProcessorOptions();
        const assetPaths = this.configProvider.getAssetPaths();

        return BackgroundProcessor({
            ...{ assetPaths },
            ...(options || {}),
        });
    }

    public async updateProcessor(
        processor: BackgroundProcessorWrapper,
        newOptions: SwitchBackgroundProcessorOptions,
    ): Promise<void> {
        if (!processor) {
            throw new Error('Processor is not initialized');
        }

        await processor.switchTo(newOptions);
    }

    public async switchToDisabled(processor: BackgroundProcessorWrapper): Promise<void> {
        if (!processor) {
            throw new Error('Processor is not initialized');
        }

        await processor.switchTo({
            mode: 'disabled',
        });
    }
}
